module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('section', [_c('h5', [_vm._v("General Remarks")]), _vm._v(" "), (_vm.isTelco() && this.isActive(this.actionData)) ? _c('div', [_c('html-input', {
    attrs: {
      "clsStyle": "width: 52.8vw; overflow: auto;",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.actionData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.actionData, "remarks", $$v)
      },
      expression: "actionData.remarks"
    }
  })], 1) : _c('div', {
    staticClass: "html-remarks"
  }, [(_vm.actionData.remarks) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.actionData.remarks)
    }
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No client remarks")])]), _vm._v(" "), (_vm.step.remarks) ? _c('hr') : _vm._e()]), _vm._v(" "), (this.isActive(this.actionData)) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Progress Remarks",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('html-input', {
    attrs: {
      "disabled": _vm.isViewOnly() || !this.isActive(this.actionData)
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39a4d4b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/step1.vue
// module id = 1511
// module chunks = 0